import { useEffect, useState } from "react";
import { api } from "@/lib/api";

/**
 * Hook di ricerca sul motore Foundation (/api/guide/search).
 * Debounced 220ms.
 *
 * @param {string} appKey
 * @param {string} query
 * @param {object} opts - { role?, limit? }
 * @returns {{ results, loading, error }}
 */
export function useGuideSearch(appKey, query, { role, limit = 20 } = {}) {
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const q = (query || "").trim();
    if (!q) {
      setResults([]);
      setLoading(false);
      setError(null);
      return undefined;
    }
    let cancelled = false;
    setLoading(true);
    const t = setTimeout(() => {
      const params = { app: appKey, q, limit };
      if (role) params.role = role;
      api
        .get("/guide/search", { params })
        .then(({ data }) => {
          if (cancelled) return;
          setResults(data?.results || []);
          setError(null);
        })
        .catch((e) => {
          if (cancelled) return;
          setError(e);
          setResults([]);
        })
        .finally(() => {
          if (cancelled) return;
          setLoading(false);
        });
    }, 220);
    return () => {
      cancelled = true;
      clearTimeout(t);
    };
  }, [appKey, query, role, limit]);

  return { results, loading, error };
}
